import {Pipe, PipeTransform} from "@angular/core";
import {Risk} from "../../store/state/order.state";
import {TranslateService} from "@ngx-translate/core";

@Pipe({
    name: 'effortName',
    standalone: false
})
export class EffortNamePipe implements PipeTransform {

	private translations;

	constructor(private translateService: TranslateService) {
		this.translateService.get([
			'pricing-details.effort-neuter',
			'pricing-details.effort-female',
			'pricing-details.effort-male'
		]).subscribe(translations => this.translations = translations)
	}

	transform(risk: Risk, gender: string): string {
		const key = `pricing-details.effort-${gender}`;
		return this.translations[key][risk.toLowerCase()];
	}
}
